export enum LevelType {
  HOT = 'hot',
  WARM = 'warm',
  MEDIUM = 'medium',
  COLD = 'cold',
  FROZEN = 'frozen',
}
